var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"manage-wrap uf",staticStyle:{"min-width":"1330px"},attrs:{"id":"manage"}},[_c('manage-sidebar',{staticClass:"side-menu"}),_c('manage-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }